import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { _ProductLine } from "../../../core/services/dataBean/EntityCatalogVdos";
import { _single } from "../../../core/services/dataBean/EntityCatalog";
import { ListMenu } from "../../theme/Component/ListMenu";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicTable, MASK_BOOLEAN_ICON, MASK_DATE, MASK_NUMBER } from "../../theme/Component/BasicTable";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { Modal } from "../../theme/Component/Modal";
import { toast } from "react-toastify";
import { SelectAccountantTree } from "../../contabilidad/catalogo-cuentas/AccountantTree/SelectAccountantTree";
import { SelectStoreEditor } from "../../contract/etapa-contrato/contrac/ublinvoice/SelectStore.editor";
import { BasicSwitch } from "../../theme/Component/BasicSwitch";

export const ProductLine = () => {

    const { lista, setLista, bean, setBean, instance, update, handleChange, deleteItemVoid } = useDataBean(_ProductLine);

    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });


    useEffect(() => {
        getLista()
    }, [])

    const getLista = () => {
        instance.getProductCatalogLine(null).then(
            (rta: any) => {
                setLista(rta)
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const editaItem = () => {
        update().then(
            (resp) => {
                getLista();
                setModal({ ...modal, "view": false })
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const deleteObjec = () => {
        deleteItemVoid(bean.IDLine).then(
            (resp) => {
                getLista();
                setModalC({ ...modalC, "view": false })
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const head = [
        { title: 'ID', property: 'IDLine', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Cuenta de Inventario', property: 'AccountantIDName', visible: true, },
        { title: 'Cuenta de Ingreso', property: 'RevenueAccountantIDName', visible: true, },
        { title: 'Cuenta de Costo de Inventario', property: 'CostAccountantIDName', visible: true },
        { title: 'Cuenta de Trabajo en Proceso (WIP)', property: 'WIPProductAccountantIDName', visible: true },
        { title: 'Cuenta de Costo de Producción', property: 'ProductionCostAccountantIDStrName', visible: true },
        { title: 'Cuenta de Producto Terminado', property: 'FinishProductAccountantIDStrName', visible: true },
        { title: 'Gestionar inventario en Cuentas de Orden', property: 'UseInventoryONControlAccountantIDs', visible: true },
        { title: 'Cuenta Control Débito', property: 'DebtControlAccountantIDStrName', visible: true },
        { title: 'Cuenta Control Crédito', property: 'CreditControlAccountantIDStrName', visible: true },
        { title: 'Cuenta de Producto Terminado en Tránsito', property: 'FinishProductInTransitAccountantIDStrName', visible: true },
        { title: 'Cuenta de Materia Prima en Tránsito a Orden de Producción', property: 'RawMaterialToOPInTransitAccountantIDStrName', visible: true },
        { title: 'Cuenta Entrada Almacén Puente Pago', property: 'InventoryEntryCreditAccountantIDStrName', visible: true },
        { title: 'Utilizar Cuenta de Costo de Producción para Traslado de Materia Prima', property: 'UseProductionCostForRawMaterialTranslate', visible: true },
        { title: 'Limitar a almacèn', property: 'IDStore', visible: true },
        { title: 'Creado', property: 'Since', visible: true },

    ]

    const create = () => {
        setBean({
            IDEmployee: _single.getAccountID(),
            Since: _single.getCurrenDate(),
        });
        setModal({ ...modal, "view": true, "name": "Agregar Grupo de Producto de Inventario" });
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "view": true, "name": "Editar Grupo de Producto de Inventario" }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true, "name": `Eliminar Grupo de Producto de Inventario` }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            editaItem();
        }
    }

    const validateForm = () => {
        const requiredFields = ["Description"];

        // Si se gestiona inventario en cuentas de orden, se requieren campos adicionales
        if (bean.UseInventoryONControlAccountantIDs) {
            requiredFields.push("DebtControlAccountantIDStr", "CreditControlAccountantIDStr");
        }

        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length;
    };


    return (
        <BasicPage titulo="Grupos de Productos de Inventario" >
            <div className="row">
                <div className="col-md-12">
                    <BasicTable listButtons={listaBotones()} head={head} body={lista} rowSet={setBean} iconButtons={iconButtonsItem} />
                </div>

                <div className="col-md-12">
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteObjec}>
                        <strong>Eliminar Informacion de {bean.IDLine} - {bean.Description}</strong>
                    </ModalConfirm>
                </div>

                <div className="col-md-12">
                    <Modal modal={modal} updateModal={setModal} eventModal={validateData}>
                        <div className="row">
                            <div className="col-md-12">
                                <label className={`${missingFields.includes('Description') ? 'has-error' : ''}`}>Descripción</label>
                                <textarea name="Description" className="form-control" value={bean.Description} onChange={handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('AccountantID') ? 'has-error' : ''}`}>Cuenta de Inventario</label>
                                <SelectAccountantTree idAccountant={bean.AccountantID} onChange={(e) => { setBean({ ...bean, "AccountantID": e.AccountantID, "AccountantIDStr": e.JsonCode }) }} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('CostAccountantID') ? 'has-error' : ''}`}>Cuenta de Costo de Inventario</label>
                                <SelectAccountantTree idAccountant={bean.CostAccountantID} onChange={(e) => { setBean({ ...bean, "CostAccountantID": e.AccountantID, "CostAccountantIDStr": e.JsonCode }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Cuenta de Trabajo en Proceso WIP</label>
                                <SelectAccountantTree idAccountant={bean.WIPProductAccountantID} onChange={(e) => { setBean({ ...bean, "WIPProductAccountantID": e.AccountantID, "WIPProductAccountantIDStr": e.JsonCode }) }} />
                            </div>
                            <div className="col-md-6">
                                {/* "ProductionCostAccountantID": e.AccountantID, */}
                                <label>Cuenta de Costo de Producción</label>
                                <SelectAccountantTree render={bean.ProductionCostAccountantIDStrName} idAccountant={bean.ProductionCostAccountantID} onChange={(e) => { setBean({ ...bean, "ProductionCostAccountantIDStrName": e.Name, "ProductionCostAccountantIDStr": e.JsonCode }) }} />
                            </div>
                            <div className="col-md-6">

                                <label>Cuenta de Producto Terminado</label>
                                <SelectAccountantTree render={bean.FinishProductAccountantIDStrName} idAccountant={bean.FinishProductAccountantID} onChange={(e) => { setBean({ ...bean, "FinishProductAccountantIDStrName": e.Name, "FinishProductAccountantIDStr": e.JsonCode }) }} />
                            </div>
                            <div className="col-md-6">


                                <label>Cuenta de Producto Terminado en Tránsito</label>
                                <SelectAccountantTree render={bean.FinishProductInTransitAccountantIDStrName} idAccountant={bean.FinishProductInTransitAccountantID} onChange={(e) => { setBean({ ...bean, "FinishProductInTransitAccountantIDStrName": e.Name, "FinishProductInTransitAccountantIDStr": e.JsonCode }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectAccountantTree label="Cuenta de Materia Prima en Tránsito a Orden de Producción" render={bean.RawMaterialToOPInTransitAccountantIDStrName} idAccountant={bean.RawMaterialToOPInTransitAccountantID} onChange={(e) => { setBean({ ...bean, "RawMaterialToOPInTransitAccountantIDStrName": e.Name, "RawMaterialToOPInTransitAccountantIDStr": e.JsonCode }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Cuenta de Ingreso</label>
                                <SelectAccountantTree idAccountant={bean.RevenueAccountantID} onChange={(e) => { setBean({ ...bean, "RevenueAccountantID": e.AccountantID, "RevenueAccountantIDStr": e.JsonCode }) }} />
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="Utilizar Cuenta Puente Entrada de Almacén" estado={bean.UseInventoryEntryCreditAccountantIDStr} eventChange={(e: any) => { setBean({ ...bean, "UseInventoryEntryCreditAccountantIDStr": e }) }}></BasicSwitch>
                            </div>
                            <div className="col-md-6">
                                <SelectAccountantTree label="Cuenta Entrada Almacén Puente Pago" jsonCode={bean.InventoryEntryCreditAccountantIDStr} onChange={(e) => { setBean({ ...bean, "InventoryEntryCreditAccountantIDStr": e.JsonCode }) }} />
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="Gestionar inventario en Cuentas de Orden" estado={bean.UseInventoryONControlAccountantIDs} eventChange={(e: any) => { setBean({ ...bean, "UseInventoryONControlAccountantIDs": e }) }}></BasicSwitch>
                            </div>
                            {bean.UseInventoryONControlAccountantIDs && <>
                                <div className="row">
                                    <div className="col-md-6">
                                        <label className={`${missingFields.includes('DebtControlAccountantIDStr') ? 'has-error' : ''}`}>Cuenta Control Débito</label>
                                        <SelectAccountantTree render={bean.DebtControlAccountantIDStrName} idAccountant={bean.DebtControlAccountantID} onChange={(e) => { setBean({ ...bean, "DebtControlAccountantIDStrName": e.Name, "DebtControlAccountantIDStr": e.JsonCode }) }} />
                                    </div>
                                    <div className="col-md-6">
                                        <label className={`${missingFields.includes('DebtControlAccountantIDStr') ? 'has-error' : ''}`}>Cuenta Control Crédito</label>
                                        <label></label>
                                        <SelectAccountantTree render={bean.CreditControlAccountantIDStrName} idAccountant={bean.CreditControlAccountantID} onChange={(e) => { setBean({ ...bean, "CreditControlAccountantIDStrName": e.Name, "CreditControlAccountantIDStr": e.JsonCode }) }} />
                                    </div>
                                </div>
                            </>}
                            <div className="col-md-6">
                                <SelectStoreEditor label="Limitar a almacèn" idSelector={bean.IDStore} onChange={(e) => { setBean({ ...bean, "IDStore": e.IDStore }) }} />
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label='Utilizar Cuenta de Costo de Producción para Traslado de Materia Prima' estado={bean.UseProductionCostForRawMaterialTranslate} eventChange={(e) => { setBean({ ...bean, "UseProductionCostForRawMaterialTranslate": e }) }} />
                            </div>
                        </div>
                    </Modal>
                </div>
            </div >
        </BasicPage >
    )
}



